import './NotifySuccess.scss';
import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import LeftArrow from '../../../assets/BlueLeftArrow.svg';
import CircleSuccess from '../../../assets/CircleSuccess.svg';

type Props = {
    setSuccess: any;
    rtl: boolean;
}

const win: any = window;

function NotifySuccess({ setSuccess, rtl }: Props) {
    const { t } = useTranslation();

    const handleBackClick = () => {
        window.location.href = win['home_page_url'];
    }

    return (
        <div className='container NotifySuccess__container'>
            <div className='row'>
                <div className='Notify__backButton' onClick={handleBackClick}>
                    <img src={LeftArrow} alt="icon" />
                    <Typography>{t('back_title')}</Typography>
                </div>
                <div className='NotifySuccess'>
                    <img src={CircleSuccess} alt="" />
                    <Typography className='NS__title'>{t('Notify_Success')}</Typography>
                    <Button className='NS__button' onClick={handleBackClick}>{t('back_title')}</Button>
                </div>
            </div>
        </div>
    )
}

export default NotifySuccess;